import { createFileRoute } from "@tanstack/react-router";

import { SKUStoreEngagementPage } from "@/features/SKUStore/SKUStoreEngagementPage";

export const Route = createFileRoute(
  "/_auth/sku-store/$siteId/$skuId/engagement",
)({
  component: SKUStoreEngagementPage,
});
